import React from "react";
import "./Developers.css";
import ApiKeys from "./ApiKeys/ApiKeys";
import Logs from "./Logs/Logs";
import Overview from "./Overview/Overview";
import StepTabs from "../../../Components/Stepbar/Steptabs";
const Developers = () => {
  const tabNames = ["Overview", "Api Keys", "Logs"];
  return (
    <div className="developer-container">
      <div className="main-developer-container">
        <div className="developer-content">
          <StepTabs size={"large "} tabNames={tabNames}>
            <Overview />
            <ApiKeys />
            <Logs />
          </StepTabs>
        </div>
      </div>
    </div>
  );
};

export default Developers;
